import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import Fetch from '../../../../core/util/core/Fetch';
import CompaniesForm from './Form';
import { getUserSession } from '../portal/functions/Session';

function List() {

    const pathFrontEnd = '/companies/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}companies/delete`,
        endpoint: config.endpoints.backend + 'companies/getall'
    }
    const pathsForm = {
        endpointSave: config.endpoints.backend + 'companies/save',
        endpointGetById: config.endpoints.backend + 'companies/getById',
        endpointGetAll: config.endpoints.backend + 'companies/getall'
    }

    const session = getUserSession();


    let list = {
        labelTitle: 'Lista de Empresas',
        labelTitleButtonAdd: 'Incluir nova empresa',
        fieldsShowOnDelete: ['corporate_name'],
        showPrintButtons: true,
        formToModal: CompaniesForm,
        columns: [
            {
                name: 'corporate_name',
                label: 'Razão Social'
            },
            {
                name: 'cnpj',
                label: 'CNPJ'
            },
            {
                name: 'fantasy_name',
                label: 'Nome Fantasia'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            },
        ]
    };


    list = { ...list, ...paths };

    let form = {
        validateOnChange: true,
        hiddenValues: {
            core_application_instance_id: session.user.application_instance_id,
            core_user_id: session.user.id
        },
        fields: [
            {
                name: 'cnpj',
                type: 'CNPJ',
                label: 'CNPJ',
                validations: {
                    required: true,
                    cnpj_unique: true
                },
                columnSize: 12
            },
            {
                name: 'corporate_name',
                type: 'text',
                label: 'Razão social',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'fantasy_name',
                type: 'text',
                label: 'Nome Fantasia',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'municipal_registration',
                type: 'text',
                label: 'Inscrição Municipal',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'estadual_registration',
                type: 'text',
                mask: '999.999.999.999',
                label: 'Inscrição Estadual',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'link',
                type: 'text',
                label: 'Link',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'photo',
                type: 'file',
                label: 'Anexo',
                uploadPath: '/companies/',
                extensionAccept: '.jpeg,.jpg,.png,.pdf',
                limitFileSize: 2,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'address',
                type: 'address',
                label: 'Endereço',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'institutional_email',
                type: 'email',
                label: 'Email Institucional',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'status',
                type: 'select',
                options: [
                    { label: 'Ativo', value: '1' },
                    { label: 'Inativo', value: '0' }
                ],
                label: 'Status',
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Empresa'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
